import VueGtag, { event, pageview, screenview } from 'vue-gtag';
import {
  hasRejectedTracking,
  hasTrackingConsent,
  installTrackingStubs,
  loadTrackingScripts,
  setBarionConsent,
} from '~/utils/tracking';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueGtag, {
    config: { id: 'G-KT9B09E9BE' },
    // includes: [
    //   { id: 'G-P4EW046BHY'}
    // ],
    // bootstrapped by loadTrackingScripts() once cookies are accepted
    bootstrap: false,
    appName: 'BNPL Client',
  });

  installTrackingStubs();
  if (hasTrackingConsent()) {
    loadTrackingScripts();
  } else if (hasRejectedTracking()) {
    setBarionConsent(false);
  }

  return {
    provide: {
      gtag: {
        event: event,
        pageview: pageview,
        screenview: screenview
      }
    }
  };
});
